import { render, staticRenderFns } from "./DashboardWidgets.vue?vue&type=template&id=0c995af0&scoped=true"
import script from "./DashboardWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardWidgets.vue?vue&type=script&lang=js"
import style0 from "./DashboardWidgets.vue?vue&type=style&index=0&id=0c995af0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c995af0",
  null
  
)

export default component.exports